import axios from 'axios'

const baseUrlApi = `${process.env.VUE_APP_API_URL_BACKEND}`;
const instance = axios.create({
  baseUrlApi: baseUrlApi
});

export { baseUrlApi };
export default instance;